import PropTypes from "prop-types";
import { ExamSettingsContext } from "./examSettingsContext";
import { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { toggle_refetch } from "../../../../../redux/slices/ExamSidebarSlice";
// import { set } from "lodash";

export const ExamSettingsContextProvider = ({ children }) => {
  const [id, setId] = useState(null);
  const [data, setData] = useState();
  // thumbnail link
  const [thumbnail, setThumbnail] = useState("");
  // string
  const [desc, setDesc] = useState("");
  // string
  const [examState, setExamState] = useState("");
  // string
  const [instruction, setInstruction] = useState("");
  // integer
  const [negativeMark, setNegativeMark] = useState(0);
  // boolean
  const [secondTimer, setSecondTimer] = useState(false);
  // integer
  const [secondTimerNegMark, setSecondTimerNegMark] = useState(0);
  // integer
  const [examTime, setExamTime] = useState(0);
  // string
  const [examType, setExamType] = useState("PRACTICE_EXAM");
  // date-time string
  const [startTime, setStartTime] = useState("");
  // data-time string
  const [endTime, setEndTime] = useState("");
  // integer
  const [maxAttempt, setMaxAttempt] = useState(0);
  // integer
  const [numOfQuestions, setNumOfQuestions] = useState(0);
  // boolean
  const [shuffle, setShuffle] = useState(true);
  const [isOffline, setIsOffline] = useState(true);
  // string
  const [questionPaper, setQuestionPaper] = useState("");
  // decimal
  const [highest, setHighest] = useState(0);
  // integer
  const [totalExamCount, setTotalExamCount] = useState(0);
  // boolean
  const [isActive, setIsActive] = useState(false);
  // boolean
  const [isResultGen, setIsResultGen] = useState(false);
  // boolean
  const [isCq, setIsCq] = useState(false);
  // boolean
  const [isCqEval, setIsCqEval] = useState(false);
  // integer
  const [org, setOrg] = useState(0);
  // integer
  const [course, setCourse] = useState(null);
  // integer
  const [lecture, setLecture] = useState(9);
  // string
  const [examLink, setExamLink] = useState("");


  const [isAnswerShow, setIsAnswerShow] = useState(false);
  const [isRightAnswerShow, setIsRightAnswerShow] = useState(false);
  const [isExplanationShow, setIsExplanationShow] = useState(false);

  const [isPollExam, setIsPollExam] = useState(false);

  const apiUrl = import.meta.env.VITE_APP_API;
  const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))
    .token.access;
  const dispatch = useDispatch();
  useEffect(() => {
    const url = `${apiUrl}/api/exam/admin/exam_question_paper/${id}/`;

    async function getExamQuestionPaperData() {
      const getData = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log(getData.data.is_poll_exam);
      setData(getData.data);
      setShuffle(getData.data.shuffle);
      setIsOffline(getData.data.is_offline);
      setSecondTimer(getData.data.second_timer);
      setInstruction(getData.data.instruction);
      setThumbnail(getData.data.thumbnail);
      setDesc(getData.data.description);
      setExamType(getData.data.exam_type);
      setIsAnswerShow(getData.data.is_answer_show);
      setIsRightAnswerShow(getData.data.is_right_answer_show);
      setIsExplanationShow(getData.data.is_explanation_show);
      setIsPollExam(getData.data.is_poll_exam);

      setSecondTimerNegMark(getData.data.second_timer_negetive_mark);
      setNegativeMark(getData.data.negetive_mark);
      setIsCq(getData.data.is_cq);
    }
    if (id) getExamQuestionPaperData();
  }, [id, access_token, apiUrl]);

  async function PatchUpdateExamData() {
    const url = `${apiUrl}/api/exam/admin/exam_question_paper/${id}/`;
    console.log("pathupdate examdata")

    const getData = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    });

    let formData = new FormData();

    formData.append("exam_name", examState || getData.data.exam_name);
    formData.append("instruction", instruction || getData.data.instruction);
    formData.append("negetive_mark", negativeMark);
    formData.append("second_timer", secondTimer);
    console.log("secondTimerNegMark", secondTimerNegMark);
    if (secondTimerNegMark) {
      formData.append("second_timer_negetive_mark", secondTimerNegMark);
    }
    formData.append("exam_time", examTime || getData.data.exam_time);
    formData.append("exam_type", examType);
    formData.append("max_attempt", maxAttempt || getData.data.max_attempt);
    formData.append("is_answer_show", isAnswerShow);
    formData.append(
      "number_of_question",
      numOfQuestions || getData.data.number_of_question
    );
    formData.append("shuffle", shuffle);
    formData.append("is_offline", isOffline);
    formData.append("is_cq", isCq);
    formData.append(
      "question_paper",
      JSON.stringify(getData.data.json_question_paper)
    );
    formData.append("description", desc);
    formData.append('is_poll_exam', isPollExam);

    if (startTime && endTime) {
      let selectedStartTime = new Date(startTime).toISOString();
      let selectedEndTime = new Date(endTime).toISOString();

      formData.append("start_time", selectedStartTime);
      formData.append("end_time", selectedEndTime);
    }

    if (getData.status === 200) {
      const patchData = await axios.patch(url, formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      dispatch(toggle_refetch()); // <-- trigger refetch for sidebar

      console.log(patchData);
    }
  }

  const url = `${apiUrl}/api/exam/admin/exam_question_paper/${id}/`;

  async function getExamQuestionPaperData() {
    const getData = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    });

    setThumbnail(getData.data.thumbnail);
    setDesc(getData.data.description);
  }

  return (
    <ExamSettingsContext.Provider
      value={{
        id,
        setId,
        examState,
        setExamState,
        instruction,
        setInstruction,
        negativeMark,
        setNegativeMark,
        secondTimer,
        setSecondTimer,
        secondTimerNegMark,
        setSecondTimerNegMark,
        examTime,
        setExamTime,
        examType,
        setExamType,
        startTime,
        setStartTime,
        endTime,
        setEndTime,
        maxAttempt,
        setMaxAttempt,
        numOfQuestions,
        setNumOfQuestions,
        shuffle,
        setShuffle,
        isOffline,
        setIsOffline,
        questionPaper,
        setQuestionPaper,
        highest,
        setHighest,
        totalExamCount,
        setTotalExamCount,
        isActive,
        setIsActive,
        isResultGen,
        setIsResultGen,
        isCq,
        setIsCq,
        isCqEval,
        setIsCqEval,
        org,
        setOrg,
        course,
        setCourse,
        lecture,
        setLecture,
        examLink,
        setExamLink,
        data,
        setData,
        PatchUpdateExamData,
        thumbnail,
        setThumbnail,
        desc,
        setDesc,
        getExamQuestionPaperData,
        isAnswerShow,
        setIsAnswerShow,
        isRightAnswerShow,
        setIsRightAnswerShow,
        isExplanationShow,
        setIsExplanationShow,
        isPollExam,
        setIsPollExam,
      }}
    >
      {children}
    </ExamSettingsContext.Provider>
  );
};

ExamSettingsContextProvider.propTypes = {
  children: PropTypes.any,
};
